export function irisFormat(value) {
  const match=String(value).match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/i);
  if (!match) return null;
  const a=Number(match[1].replace(',','.')),b=Number(match[2].replace(',','.'));
  if (!(a>0 && b>0)) return null;
  const ratio=Math.max(a,b)/Math.min(a,b);
  const group=Math.abs(ratio-1)<.001?'square':Math.abs(ratio-1.5)<.001?'32':Math.abs(ratio-4/3)<.001?'43':ratio>=2?'panorama':null;
  return group?{value,group,area:a*b,width:Math.max(a,b)}:null;
}
export function irisSizes(values, group) {
  return [...new Set(values)].map(irisFormat).filter(v=>v && v.group===group).sort((a,b)=>a.area-b.area || a.width-b.width).map(v=>v.value);
}
export function irisVariant(variants, values) {
  return variants.find(v=>v.options.length===values.length && v.options.every((o,i)=>o===values[i]));
}
export function setupIrisProduct(root) {
  if (root.dataset.ready) return;
  const data=JSON.parse(root.querySelector('[data-iris-product-json]').textContent);
  const copy=JSON.parse(root.querySelector('[data-iris-copy]').textContent);
  const form=root.querySelector('.iris-product-form');
  const native=form.querySelector('[data-iris-variant]');
  const selectors=Array.from(form.querySelectorAll('[data-option-index]'));
  const submit=form.querySelector('[data-iris-submit]');
  const storageKey='iris-product-v1:'+location.pathname;
  let saved=null;
  try { const value=JSON.parse(sessionStorage.getItem(storageKey)); if(value && Date.now()-value.time<7200000) saved=value; } catch {}
  const explicit=new URL(location.href).searchParams.get('variant');
  if(saved && !explicit && data.variants.some(v=>String(v.id)===saved.variant)) native.value=saved.variant;
  const current=data.variants.find(v=>String(v.id)===native.value) || data.variants[0];
  if (!current) return;
  const money=new Intl.NumberFormat(document.documentElement.lang || 'de-DE',{style:'currency',currency:'EUR'});
  const addonData=JSON.parse(root.querySelector('[data-iris-addons]')?.textContent || '[]');
  const addon=form.querySelector('[data-iris-addon]');
  const material=form.querySelector('[data-addon-material]');
  const extraSize=form.querySelector('[data-addon-size]');
  const extraGroup=form.querySelector('[data-addon-group]');
  const mount=form.querySelector('[data-addon-mount]');
  const surface=form.querySelector('[data-addon-surface]');
  const extraQuantity=form.querySelector('[data-addon-quantity]');
  let busy=false;
  const quantity=()=>Number(form.elements.quantity.value);
  const validQuantity=n=>Number.isInteger(n) && n>=1 && n<=20;
  function extraProduct(){return addonData.find(p=>p.handle===material?.value);}
  function extraVariant(){
    const product=extraProduct();
    if(!product)return null;
    const delivery=readVariant()?.options.at(-1);
    return product.variants.find(v=>v.options[0]===extraSize.value && v.options.at(-1)===delivery && (v.options.length===2 || v.options[1]===mount.value));
  }
  function choices(select,values,wanted){
    select.replaceChildren(...[...new Set(values)].map(value=>new Option(value,value)));
    if(values.includes(wanted))select.value=wanted;
  }
  function configureExtra(restore){
    const product=extraProduct();
    if(!addon)return;
    form.querySelector('[data-addon-fields]').hidden=!product;
    extraQuantity.required=Boolean(product);
    if(!product)return;
    const wanted=restore?.size || extraSize.value;
    if(restore?.size)extraGroup.value=irisFormat(restore.size)?.group || 'square';
    choices(extraSize,irisSizes(product.variants.map(v=>v.options[0]),extraGroup.value),wanted);
    const alu=product.handle==='geschenkgutschein-iris-alu';
    choices(mount,alu?product.variants.map(v=>v.options[1]):[''],restore?.mount || mount.value);
    form.querySelector('[data-addon-mount-label]').hidden=!alu;
    form.querySelector('[data-addon-surface-label]').hidden=!alu;
    if(restore?.surface && ['Matt','Hochglanz'].includes(restore.surface))surface.value=restore.surface;
    if(validQuantity(Number(restore?.quantity)))extraQuantity.value=restore.quantity;
  }
  const fields=Array.from(form.querySelectorAll('input[name="quantity"], input[name^="properties["], select[name^="properties["], textarea[name^="properties["]')).filter(el=>el.type!=='hidden');
  if(saved) fields.forEach(el=>{
    const value=saved.fields?.[el.name];if(typeof value!=='string')return;
    if(el.tagName==='SELECT' && !Array.from(el.options).some(o=>o.value===value))return;
    if(el.name==='quantity' && !/^(?:[1-9]|1[0-9]|20)$/.test(value))return;
    el.value=value.slice(0,el.maxLength>0?el.maxLength:200);
  });
  function save() {
    const variant=native.value;
    try {sessionStorage.setItem(storageKey,JSON.stringify({time:Date.now(),variant,fields:Object.fromEntries(fields.map(el=>[el.name,el.value])),addon:material?{material:material.value,size:extraSize.value,mount:mount.value,surface:surface.value,quantity:extraQuantity.value}:null,scroll:window.scrollY}));} catch {}
  }
  fields.forEach(el=>el.addEventListener('input',()=>{update();}));
  window.addEventListener('pagehide',save);
  window.addEventListener('load',()=>{if(saved && Number.isFinite(saved.scroll)) window.scrollTo(0,saved.scroll);},{once:true});
  const readVariant=()=>irisVariant(data.variants,selectors.map(s=>s.value));
  if(addon){
    addon.hidden=false;
    if(saved?.addon && addonData.some(p=>p.handle===saved.addon.material)){material.value=saved.addon.material;addon.open=true;}
    configureExtra(saved?.addon);
    material.addEventListener('change',()=>{configureExtra();update();});
    extraGroup.addEventListener('change',()=>{configureExtra();update();});
    [extraSize,mount,surface,extraQuantity].forEach(el=>el.addEventListener('input',update));
  }
  if(fields.some(el=>el.name.startsWith('properties[') && el.value.trim() && el.tagName!=='SELECT')){
    const dedication=form.querySelector('.iris-dedication');if(dedication)dedication.open=true;
  }
  const mobileBuy=root.querySelector('[data-iris-mobile-buy]');
  const mobileSubmit=root.querySelector('[data-iris-mobile-submit]');
  if(mobileBuy && mobileSubmit){
    mobileSubmit.addEventListener('click',()=>form.requestSubmit(submit));
    new IntersectionObserver(entries=>{mobileBuy.hidden=entries[0].isIntersecting;},{threshold:0}).observe(submit);
  }
  function update() {
    const variant=readVariant();
    native.value=variant?String(variant.id):'';
    root.querySelector('[data-iris-price]').textContent=variant?money.format(variant.price/100):'—';
    if(variant) {const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(history.state,'',url);}
    save();
    const delivery=variant?variant.options.at(-1):'';
    root.querySelector('[data-iris-delivery]').textContent=delivery.includes('E-Mail')?copy.pah:delivery.includes('Post')?copy.post:delivery?copy.pickup:'';
    const extra=extraVariant(),hasExtra=Boolean(extraProduct());
    const quantitiesValid=validQuantity(quantity()) && (!hasExtra || validQuantity(Number(extraQuantity.value)));
    const valid=Boolean(variant?.available) && (!hasExtra || Boolean(extra?.available)) && quantitiesValid;
    const extraPrice=form.querySelector('[data-addon-price]');if(extraPrice)extraPrice.textContent=extra?money.format(extra.price/100):'—';
    const total=root.querySelector('[data-iris-total]');
    if(total)total.textContent=valid?money.format((variant.price*quantity()+(hasExtra?extra.price*Number(extraQuantity.value):0))/100):'—';
    const count=root.querySelector('[data-iris-count]');if(count)count.textContent=valid?copy.countLabel+': '+(quantity()+(hasExtra?Number(extraQuantity.value):0)):'';
    form.querySelector('[data-iris-error]').textContent=valid?'':copy.missing;
    submit.disabled=busy || submit.dataset.review==='true' || !valid;
    if (submit.dataset.review!=='true') submit.textContent=variant && variant.available?copy.add:copy.unavailable;
    if(mobileSubmit){mobileSubmit.disabled=submit.disabled;mobileSubmit.textContent=submit.textContent;root.querySelector('[data-iris-mobile-total]').textContent=total?.textContent || '—';}
  }
  selectors.forEach((select,i)=>{select.value=current.options[i];select.addEventListener('change',update);});
  const size=form.querySelector('[data-iris-format-size]');
  const picker=form.querySelector('[data-iris-format-picker]');
  if (size && picker) {
    const formats=Array.from(size.options,o=>o.value);
    const remembered=new Map();
    const buttons=Array.from(picker.querySelectorAll('[data-format-group]'));
    let active=irisFormat(size.value)?.group;
    function choose(group,preferred) {
      const values=irisSizes(formats,group);
      if (!values.length) return;
      if (active) remembered.set(active,size.value);
      const wanted=preferred || remembered.get(group);
      size.replaceChildren(...values.map(value=>new Option(value,value)));
      size.value=values.includes(wanted)?wanted:values[0];
      active=group;
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.formatGroup===group)));
      picker.querySelector('[data-iris-group-hint]').textContent=copy.hints[group] || '';
      update();
    }
    const allRecognized=formats.every(v=>irisFormat(v));
    if (allRecognized && active) {
      buttons.forEach(button=>{const group=button.dataset.formatGroup;button.hidden=!irisSizes(formats,group).length;button.addEventListener('click',()=>choose(group));});
      choose(active,size.value);picker.hidden=false;
    }
  }
  native.closest('label').hidden=true;
  form.querySelector('[data-iris-options]').hidden=false;
  form.addEventListener('submit',async event=>{
    if(submit.disabled || !readVariant()){event.preventDefault();return;}
    if(!extraProduct())return;
    event.preventDefault();
    const extra=extraVariant();if(!extra?.available || !form.reportValidity())return;
    const properties=Object.fromEntries(Array.from(new FormData(form)).filter(([name,value])=>name.startsWith('properties[') && String(value).trim()).map(([name,value])=>[name.slice(11,-1),value]));
    const extraProperties={...properties};
    if(extraProduct().handle==='geschenkgutschein-iris-alu')extraProperties['Oberfläche']=surface.value;
    busy=true;submit.disabled=true;submit.textContent=copy.sending;
    if(mobileSubmit){mobileSubmit.disabled=true;mobileSubmit.textContent=copy.sending;}
    form.querySelector('[data-iris-error]').textContent='';
    const checkCart=form.querySelector('[data-iris-check-cart]');if(checkCart)checkCart.hidden=true;
    try{
      const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:readVariant().id,quantity:quantity(),properties},{id:extra.id,quantity:Number(extraQuantity.value),properties:extraProperties}]})});
      if(!response.ok)throw new Error('cart_add_failed');
      window.location.assign(form.elements.return_to.value);
    }catch{
      busy=false;update();form.querySelector('[data-iris-error]').textContent=copy.cartError;if(checkCart)checkCart.hidden=false;
    }
  });
  root.dataset.ready='true';update();
}
if (typeof document!=='undefined') {
  document.querySelectorAll('[data-iris-product]').forEach(setupIrisProduct);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-iris-product]').forEach(setupIrisProduct));
}
